import { isNil } from "ramda"

import { httpRequest, endpoint } from "@cirrus/core/http"

export const scheduleAssessmentGet = async (params) =>
  await httpRequest.get(
    endpoint.withRoot("/api/v1/author/delivering/schedule/schedule-assessments"),
    { params },
  )

export const availableGroupsGet = async () =>
  await httpRequest.get(endpoint.withRoot(`/api/v1/author/delivering/schedule/availablegroups`))

export const externalIdGet = async (name) =>
  await httpRequest.get(
    endpoint.withRoot(`/api/v1/author/delivering/schedule/externalid?name=${name}`),
  )

export const checkExternalId = async ({ externalId, scheduleId }) =>
  await httpRequest.get(
    endpoint.withRoot(
      `/api/delivering/external-id/can-use?externalId=${externalId}${
        !isNil(scheduleId) ? `&scheduleId=${scheduleId}` : ""
      }`,
    ),
  )

export const createSchedulePOST = async (params) =>
  await httpRequest.post(endpoint.withRoot(`/api/delivering/create`), params)
